import { useState, useEffect } from "react";
import { api } from "../lib/api";

/**
 * usePlans — fetches the admin-editable plan catalog from /api/plans.
 * Returns { plans, loading, refresh }. Plans are ordered and only active ones.
 */
export function usePlans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/plans");
      setPlans(data.plans || []);
    } catch {
      setPlans([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);
  return { plans, loading, refresh };
}
